"use strict";

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _this = this;

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var bluebird_1 = __importDefault(require("bluebird"));

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var entities_1 = require("../entities");

var CHUNK_SIZE = 200;
/**
 * @hidden
 */

exports.updateDividendsTaxWithholdingListResolver = function (factories, symbol, percentageChunk, addresses) {
  return function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Promise.all(addresses.map(function (address, addressIndex) {
                return factories.taxWithholdingFactory.update(entities_1.TaxWithholding.generateId({
                  securityTokenId: entities_1.SecurityToken.generateId({
                    symbol: symbol
                  }),
                  tokenholderAddress: address
                }), {
                  percentage: percentageChunk[addressIndex]
                });
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};
/**
 * Procedure that modifies dividend tax withholding percentages for holders of the Security Token
 */


var UpdateDividendsTaxWithholdingList =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(UpdateDividendsTaxWithholdingList, _Procedure_1$Procedur);

  function UpdateDividendsTaxWithholdingList() {
    var _this2;

    _classCallCheck(this, UpdateDividendsTaxWithholdingList);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(UpdateDividendsTaxWithholdingList).apply(this, arguments));
    _this2.type = types_1.ProcedureType.UpdateDividendsTaxWithholdingList;
    return _this2;
  }
  /**
   * Modify tax withholding percentage for tokenholders
   *
   * Note that this procedure will fail if:
   * - The Security Token doesn't exist
   * - The Dividends Feature hasn't been enabled
   */


  _createClass(UpdateDividendsTaxWithholdingList, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        var _this$args, symbol, investors, percentages, _this$context, contractWrappers, factories, _ref, _ref2, dividendsModule, tokenholderAddressChunks, percentageChunks;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$args = this.args, symbol = _this$args.symbol, investors = _this$args.tokenholderAddresses, percentages = _this$args.percentages;
                _this$context = this.context, contractWrappers = _this$context.contractWrappers, factories = _this$context.factories;
                _context3.prev = 2;
                _context3.next = 5;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 5:
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](2);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 10:
                _context3.next = 12;
                return contractWrappers.getAttachedModules({
                  moduleName: contract_wrappers_1.ModuleName.ERC20DividendCheckpoint,
                  symbol: symbol
                }, {
                  unarchived: true
                });

              case 12:
                _ref = _context3.sent;
                _ref2 = _slicedToArray(_ref, 1);
                dividendsModule = _ref2[0];

                if (dividendsModule) {
                  _context3.next = 17;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "The Dividends Feature hasn't been enabled"
                });

              case 17:
                tokenholderAddressChunks = lodash_1.chunk(investors, CHUNK_SIZE);
                percentageChunks = lodash_1.chunk(percentages, CHUNK_SIZE);
                _context3.next = 21;
                return bluebird_1.default.each(tokenholderAddressChunks, function (addresses, chunkIndex) {
                  return __awaiter(_this3, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee2() {
                    var percentageChunk;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            percentageChunk = percentageChunks[chunkIndex];
                            _context2.next = 3;
                            return this.addTransaction(dividendsModule.setWithholding, {
                              tag: types_1.PolyTransactionTag.SetErc20TaxWithholding,
                              // Update all affected tax withholding entities.
                              // We do this without fetching the data from the contracts
                              // because it would take too many requests and it's only one value that changes
                              resolvers: [exports.updateDividendsTaxWithholdingListResolver(factories, symbol, percentageChunk, addresses)]
                            })({
                              investors: addresses,
                              withholding: percentageChunk.map(function (percentage) {
                                return new contract_wrappers_1.BigNumber(percentage);
                              })
                            });

                          case 3:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, this);
                  }));
                });

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 7]]);
      }));
    }
  }]);

  return UpdateDividendsTaxWithholdingList;
}(Procedure_1.Procedure);

exports.UpdateDividendsTaxWithholdingList = UpdateDividendsTaxWithholdingList;